import { useContext, useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import { createTrialSubMenu } from "src/routing/navigation";

const TrialSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);

    const subMenu = useMemo(() => {
        if (!trialIdentity) {
            return null;
        }

        return createTrialSubMenu(trialIdentity);
    }, [trialIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default TrialSubMenu;
